import { render, staticRenderFns } from "./Shooters.vue?vue&type=template&id=32851652&scoped=true"
import script from "./Shooters.vue?vue&type=script&lang=js"
export * from "./Shooters.vue?vue&type=script&lang=js"
import style0 from "./Shooters.vue?vue&type=style&index=0&id=32851652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32851652",
  null
  
)

export default component.exports